import SearchRequest from "@wwdev/product/SearchRequest";

SearchRequest.pushHistory = true;

SearchRequest.doRequest = async function(withReload = false) {
	await jQuery.get(window.location.pathname, this.request, this.handleResponse.bind(withReload));
	try {
		delete this.request.module;
	} catch (e) {
	}

	if(this.pushHistory && this.pushHistory === true) {
		history.pushState(this.request, 'step', window.location.pathname + '?' + jQuery.param(this.request));
	}

	if(withReload) {
		location.reload();
	}
	return false;
}

SearchRequest.hasOptionGroup = function (groupId){
	if (!this.request.hasOwnProperty('option')) {
		return false;
	}
	return this.request.option.hasOwnProperty(groupId);
}

SearchRequest.hasSubproductGroup = function (groupId){
	if (!this.request.hasOwnProperty('subproducts')) {
		return false;
	}
	return this.request.subproducts.hasOwnProperty(groupId);
}

SearchRequest.clearOptionByGroupId = function(groupId) {
	try {
		delete this.request.option[groupId];
		delete this.request.amounts[groupId];
	} catch (err) {
	}
}

SearchRequest.clearSubproductsByGroupId = function(groupId) {
	if(this.request.subproducts.hasOwnProperty(groupId)) {
		delete this.request.subproducts[groupId];
	}
}

SearchRequest.addOption = function(groupId, optionId, amount) {
	if (!this.request.hasOwnProperty('option')) {
		this.request.option = {};
	}

	this.request.option[groupId] = optionId;

	if (!this.request.hasOwnProperty('amounts')) {
		this.request.amounts = {};
	}

	if (!this.request.amounts.hasOwnProperty(groupId)) {
		this.request.amounts[groupId] = {}
	}

	this.request.amounts[groupId][optionId] = amount;
}

SearchRequest.addSubproduct = function(groupId, productId, subproductId) {
	if (!this.request.hasOwnProperty('subproducts')) {
		this.request.subproducts = {};
	}

	if(!this.request.subproducts.hasOwnProperty(groupId)) {
		this.request.subproducts[groupId] = {};
	}

	this.request.subproducts[groupId][subproductId] = subproductId;
}

export default SearchRequest;